import { useIDBKeyval } from "@vueuse/integrations/useIDBKeyval.mjs";
import type { Ref } from "vue";
export type Variant = {
  id: string;
  name: string;
  color: string;
};

const { data } = useIDBKeyval<Variant[]>("variants", [], {
  shallow: false,
});
export function variantsState(): Ref<Variant[]> {
  return data;
}
